module.exports = __webpack_public_path__ + "static/img/KW@2x.070932b0.jpg";